import { isBefore } from 'date-fns';
export default function isSelectable(_ref) {
  let {
    minDate,
    maxDate,
    date
  } = _ref;
  if (minDate && isBefore(date, minDate) || maxDate && isBefore(maxDate, date)) {
    return false;
  }
  return true;
}
//# sourceMappingURL=isSelectable.js.map